module.exports = __webpack_public_path__ + "img/tencent_data.c81e5510.png";